export default "__VITE_ASSET__BHMjlIGJ__"